import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import styles from "./accordion.module.scss";
import AccordionItem from "./AccordionItem/accordionItem";

const Accordion = ({ items, className }) => (
    <div className={clsx(styles.accordion, className)}>
      {items?.map(({title, text, shouldRenderWithBreaks}) => {
        return <AccordionItem title={title} text={text} shouldRenderWithBreaks={shouldRenderWithBreaks} />
      })}
    </div>
  );

Accordion.propTypes = {
  items: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    shouldRenderWithBreaks: PropTypes.bool
  }),
  className: PropTypes.oneOf([PropTypes.string, PropTypes.object])
};

export default Accordion;
